// Console delegation V1.0; 2026-10-07 09:05:47 CST; parent dcebd36069b2ddb3e45e586f2c90a0214b9a2a4f.
import { endDelegation } from './auth/delegationSession';
// HotX Console 0.1.128；实际修改时间：2026-10-01 12:08:00 CST；精确父基线：8134c31a7bebab26fc7880ade220dc0bb8bfe694；变更：TRAFFIC-TIME-LOCALE-ZH-20261001。
import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/dist/index.css';
import { createPinia } from 'pinia';
import App from './App.vue';
import { createConsoleRouter } from './router';
import { consoleSessionGuard, tokenStorage } from './api/client';
import './styles.css';

if (['/delegation', '/delegation-ended'].includes(window.location.pathname)) endDelegation();

const app = createApp(App);
const router = createConsoleRouter(tokenStorage, undefined, {
  uatIpBypassEnabled: import.meta.env.VITE_UAT_IP_BYPASS_ENABLED === 'true',
  sessionGuard: consoleSessionGuard
});

app.use(createPinia());
app.use(ElementPlus, { locale: zhCn });
app.use(router);
app.mount('#app');
